import { transformCurrencyAmountDto } from 'data/transformers/currency-amount';
export const transformInvoiceLineDto = line => {
  const {
    id,
    amount,
    date,
    title,
    subtitle,
    type,
    entity_id,
    entity_type
  } = line;
  return {
    id,
    amount: transformCurrencyAmountDto(amount),
    date,
    title,
    subtitle,
    type,
    entityId: entity_id,
    entityType: entity_type
  };
};
export const transformInvoiceLinesDto = lines => lines.map(transformInvoiceLineDto);
export const transformWalletInvoices = walletInvoices => {
  var _walletInvoices$histo;

  return {
    invoiceLines: transformInvoiceLinesDto(walletInvoices.invoice_lines),
    startBalance: transformCurrencyAmountDto(walletInvoices.previous_balance),
    endBalance: transformCurrencyAmountDto(walletInvoices.balance),
    startingDate: walletInvoices.starting_date,
    history: (_walletInvoices$histo = walletInvoices.history) === null || _walletInvoices$histo === void 0 ? void 0 : _walletInvoices$histo.map(history => ({
      title: history.title,
      year: history.year,
      month: history.month,
      balance: transformCurrencyAmountDto(history.balance)
    }))
  };
};